<template>
  <div class="content_box">
    <el-breadcrumb separator="/">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">进度管理</el-breadcrumb-item> -->
      <el-breadcrumb-item
        ><a @click="$router.back(-1)">批次运单明细</a></el-breadcrumb-item
      >
      <el-breadcrumb-item> 物流查询 </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_boxs">
      <div class="line"></div>
      <div class="title_text">物流状态</div>
    </div>
    <el-row :gutter="20">
      <el-col :span="20">
        <div class="grid-content bg-purple" style="margin-bottom: 23px">
          <div class="center_box_l">
            <div class="center_boxleft">
              <div class="text_op">舒誉单号：{{ order.ordernumber }}</div>
              <div class="font_wight text_op">
                国内单号：{{ order.domesticnumber }}
              </div>
              <div class="font_wight text_op">线路：{{ order.route }}</div>
            </div>
          </div>
        </div>
        <el-row>
          <el-col :span="12"
            ><div class="grid-content bg-purple status_l">时间</div></el-col
          >
          <el-col :span="12"
            ><div class="grid-content bg-purple-light status_l">
              状态
            </div></el-col
          >
        </el-row>

        <div
          class="details_box_s"
          v-for="(item, index) in logisticsData"
          :key="index"
        >
          <div class="details_box_l">
            <div class="line_box"></div>
          </div>
          <div class="details_box_l">
            <div class="status_details">{{ item.time }}</div>
            <div>
              <div class="circle"></div>
            </div>
            <div class="status_details">{{ item.context }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
export default {
  data() {
    return {
      order: "",
      isfromchina: "",
      logisticsData: [],
      logisticsDatas: [],
     
    };
  },
  created() {
    this.batchId = this.$route.query.id;
    this.order = JSON.parse(localStorage.getItem("order"));
    this.getAllOrderStatusData(this.order.ordernumber);
  },
  methods: {
    getAllOrderStatusData() {
      // orderNumber
      var data = {
        orderNumber: this.order.ordernumber,
      };
      crudDept.getAllOrderStatusData(data).then((res) => {
        this.logisticsData = res.domesticDate;
      });
    },
    //订单国内物流
    queryExpress(code, num, id) {
      var data = {
        code: code,
        num: num,
      };
      crudDept.queryExpress(data).then((res) => {
        this.logisticsData = res.data;
      });
    },
    //批次物流
    orderstatus(orderNumber) {
      var data = {
        orderNumber: orderNumber,
      };
      crudDept.getAllOrderStatus(data).then((res) => {
        this.logisticsDatas = res.internationalData;
        this.logisticsData = res.domesticDate;
        this.isfromchina = res.isfromchina;
      });
    },
  },
};
</script>
<style scoped>
.line_box {
  width: 1px;
  height: 60px;
  background-color: #f0f0f0;
}
.status_details {
  width: 50%;
  text-align: center;
  padding: 0 30px;
  box-sizing: border-box;
}
.circle {
  width: 20px;
  height: 20px;
  background: #dddddd;
  border-radius: 50%;
}
.el-divider--vertical {
  height: 2em;
}

.details_box_l {
  display: flex;
  justify-content: center;
  align-items: center;
}
.status_l {
  height: 42px;
  line-height: 42px;
  background: #e7edf8;
  text-align: center;
}
.status_text {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 21px;
  color: #5178ff;
  text-align: center;
}
.text_op {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 21px;
  color: #2e3136;
  margin-bottom: 13px;
}
.font_wight {
  font-weight: normal !important;
}
.center_boxleft {
}
.center_box_l {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content_boxs {
  display: flex;
  align-items: center;
  margin: 40px 0;
}
.line {
  width: 4px;
  height: 24px;
  background-color: #5178ff;
  border-radius: 20px;
}
.title_text {
  font-size: 25px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #333333;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/logistics/logistics.vue